<template>
  <div class="container">
    <div class="card " style="margin-top: 0px;">
        <div class="card-content blue-grey darken-1">
          <a href="https://presentaciones.ztec.systems/?presentacion=67866d7b-0ba6-40de-811d-f8abce6e9cff" target="_blank"  class="btn-floating btn-large waves-effect waves-light " style="float: right;"><i class="material-icons">help</i></a>
          <div class="card-image" style="text-align:-webkit-center"> 
          <img alt="Vue logo" src="@/assets/cash1.svg" style="height: 30vh; width:auto">
          </div>
            

    <div class="row">
   
  
    <div class="input-field col s6">
          <input id="total" type="text"  v-model="total">
          <label for="total">Total</label>
        </div>
        <div class="input-field col s6">
          <input id="enganche" type="text" v-model="enganche">
          <label for="last_name">Enganche</label>
        </div>
        <div class="input-field col s6">
          <input id="pagos" type="text"  v-model="pagos">
          <label for="last_name">Número de pagos</label>
        </div>
          <div class="input-field col s6">
          <input id="interes" type="text"  v-model="interes">
          <label for="interes">Interés mensual</label>
        </div>
        </div>
  <ul class="collapsible">
    <li >
      <div class="collapsible-header"><i class="material-icons">filter_drama</i>Opcionales</div>
      <div class="collapsible-body">
          <div class="input-field col s6">
          <input id="numero" type="text"  v-model="numero">
          <label for="numero">Número Cotización</label>
        </div>
        <div class="input-field col s6">
          <input id="cliente" type="text"  v-model="cliente">
          <label for="cliente">Cliente</label>
        </div>
        <div class="input-field col s6">
          <input id="vendedor" type="text"  v-model="vendedor">
          <label for="vendedor">Vendedor</label>
        </div>
        <div class="input-field col s6">
          <input id="vigencia" type="text"  v-model="vigencia">
          <label for="vigencia">Vigencia</label>
        </div>
        <div class="input-field col s6">
          <input id="cantidad" type="text"  v-model="cantidad">
          <label for="cantidad">Cantidad</label>
        </div>
        <div class="input-field col s6">
          <input id="unidad" type="text"  v-model="unidad">
          <label for="unidad">Unidad</label>
        </div>
        <div class="input-field col s6">
          <input id="descripcion" type="text"  v-model="descripcion">
          <label for="descripcion">Descripción</label>
        </div>
        <div class="input-field col s6">
          <input id="unitario" type="text"  v-model="unitario">
          <label for="unitario">Unitario</label>
        </div>
       
        <div class="input-field col s6">
          <input id="condicion1" type="text"  v-model="condicion1">
          <label for="condicion1">Condicion 1</label>
        </div>
        <div class="input-field col s6">
          <input id="condicion2" type="text"  v-model="condicion2">
          <label for="condicion2">Condicion 2</label>
        </div>
        <div class="input-field col s6">
          <input id="pie1" type="text"  v-model="pie1">
          <label for="pie1">Pie 1</label>
        </div>
        <div class="input-field col s6">
          <input id="pie2" type="text"  v-model="pie2">
          <label for="pie2">Pie 2</label>
        </div>
        <div class="input-field col s6">
          <input id="pie3" type="text"  v-model="pie3">
          <label for="pie3">Pie 3</label>
        </div>
        <div class="input-field col s6">
          <input id="pie4" type="text"  v-model="pie4">
          <label for="pie4">Pie 4</label>
        </div>   
        
      </div>
    </li>
   
  </ul>
    <p>
      
        
       <!-- <button  @click="GenerateURL($event)" >Genera cotización</button>
        <a  class="waves-effect waves-light btn"><i class="material-icons left">cloud</i>Con tu archivo</a>-->
        
        
        
   
        <a @click="GenerateURL($event)" class="waves-effect waves-light btn" style="width: 100%;"><i class="material-icons left">cloud_done</i>Generar</a>
        
       
        <div style="padding-top: 20px;color: #fff;">
         Tambien puedes personalizar tu archivo, usa la plantilla
      </div>
       
        <div class="file-field input-field">
          <a href="https://cotizador.ztec.systems/cot.docx" target="_blank">
          <div class="btn" style="width: 100%;">
            
            <span><i class="material-icons left">cloud_download</i>Plantilla</span>
            
            
          </div>
          </a>
          <div class="file-path-wrapper" style="width: 0;height: 0;">
            <input class="file-path validate" type="text">
          </div>
        </div>
        
     
      <div class="col s6">
        <div class="file-field input-field">
          <div class="btn" style="width: 100%;">
            <span><i class="material-icons left">cloud_upload</i>Tu archivo</span>
            <input  id="doc" ref="myFiles" @change="ArchivoSeleccionado" type="file">
          </div>
          <div class="file-path-wrapper" style="width: 0;height: 0;">
            <input class="file-path validate" type="text">
          </div>
        </div>
     
    </div>
        
        
    </p>
   
      
  </div>
  </div>
   
  </div>
</template>

<script>
import docx_service from '@/services/docx';
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data: function(){
      return {
        cliente:"",
        total:"",
        enganche:"",
        pagos:"",
        interes:"",
        numero:"",
        cliente:"",
        vendedor:"",
        vigencia:"",
        cantidad:"",
        unidad:"",
        descripcion:"",
        unitario:"",
        condicion1:"",
        condicion2:"",
        pie1:"",
        pie2:"",
        pie3:"",
        pie4:"",
      }
    },
    mounted() {
      document.addEventListener('DOMContentLoaded', function() {
        var elems = document.querySelectorAll('.collapsible');
        var instances = M.Collapsible.init(elems, {});
      });
  
  
    },
  methods: {
    Generate(e) {
        e.preventDefault();
           docx_service.generate();       
        },
        ArchivoSeleccionado(e)
        {
          if(this.isNumber(+this.total)&& this.isNumber(++this.enganche)&& this.isNumber(+this.pagos)&&  this.isNumber(+this.interes))
        {
          if(+this.total>0 && +this.enganche>0 && +this.pagos>0)
          {
          
        //    console.log(e.target.files);
            var docs = document.getElementById("doc");
         //   e.preventDefault();
        var campos = {
          cliente:this.cliente,total:+this.total,enganche:+this.enganche,pagos:+this.pagos,interes:+this.interes,
          numero:this.numero, cliente:this.cliente, vendedor:this.vendedor, vigencia:this.vigencia,
          cantidad:this.cantidad, unidad:this.unidad, descripcion:this.descripcion, unitario:this.unitario,
          condicion1:this.condicion1, condicion2:this.condicion2, pie1:this.pie1, pie2:this.pie2, pie3:this.pie3, pie4:this.pie4
        }
        //console.log(docs)
        //console.log(docs.files)
           docx_service.generateLocal(campos,e.target);       
          }else{
            alert("Total, Enganche, Número de pagos e Interés deben ser mayores a 0")
          }
        }else{
          alert("Total, Enganche, Número de pagos e Interés deben ser números")
        }
        
          this.$refs.myFiles.value = '';
        
        },
        isNumber(value) {
        
             return (typeof value === 'number' && isFinite(value));
        
      },
       
        GenerateURL(e) {
        e.preventDefault();

        if(this.isNumber(+this.total)&& (this.enganche == "0" || this.isNumber(+this.enganche) )&& this.isNumber(+this.pagos)&&   (this.interes == "0" || this.isNumber(+this.interes)))
        {
          if(+this.total>0 && +this.enganche>=0 && +this.pagos>0)
          {
        var campos = {
          cliente:this.cliente,total:+this.total,enganche:+this.enganche,pagos:+this.pagos,interes:+this.interes,
          numero:this.numero, cliente:this.cliente, vendedor:this.vendedor, vigencia:this.vigencia,
          cantidad:this.cantidad, unidad:this.unidad, descripcion:this.descripcion, unitario:this.unitario,
          condicion1:this.condicion1, condicion2:this.condicion2, pie1:this.pie1, pie2:this.pie2, pie3:this.pie3, pie4:this.pie4
        }
           //docx_service.generateURL(campos,'http://34.222.122.203:8080/cot.docx');       
           docx_service.generateURL(campos,'https://cotizador.ztec.systems/cot.docx');       
          }else{
            alert("Total, Enganche, Número de pagos e Interés deben ser mayores a 0")
          }
        }else{
          alert("Total, Enganche, Número de pagos e Interés deben ser números")
        }
        }
        ,
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
input{
   color:#fff
}

</style>
